import React from "react";

export default class HealthCheck extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div>
                <h1>OK</h1>
            </div>
        );
    }
}